<template>
  <div>
    <ProductRecommendationsProvider
      ref="provider"
      :pageType="DY_PAGE_TYPES.cart"
      :selectorName="DY_API_CAMPAIGN_SELECTOR_NAMES.miniCartProductRecommendations"
      #default="{ title, items, isLoading }"
    >
      <ProductRecommendationsCardsSmall
        :context="$CONTEXTS.miniCart"
        v-bind="{ title, items, isLoading }"
        @select-size="onSelectSize"
      />
    </ProductRecommendationsProvider>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DY_API_CAMPAIGN_SELECTOR_NAMES } from '@/config/constants'
import ProductRecommendationsProvider from '@/components/_shared/ProductRecommendations/ProductRecommendationsProvider.vue'
import ProductRecommendationsCardsSmall from '@/components/_shared/ProductRecommendations/ProductRecommendationsCardsSmall.vue'
import { DY_PAGE_TYPES } from '@/services/external-communication/dynamic-yield/dy-events'
import { scrollElementTo } from '@/helpers/scroll'

export default {
  name: 'Recommendations',
  components: {
    ProductRecommendationsProvider,
    ProductRecommendationsCardsSmall,
  },

  data() {
    return {
      DY_API_CAMPAIGN_SELECTOR_NAMES,
      DY_PAGE_TYPES,
    }
  },

  computed: {
    ...mapGetters({
      orderSkus: 'order/skus',
    }),
  },

  watch: {
    orderSkus: 'fetchProductRecommendations',
  },

  methods: {
    fetchProductRecommendations() {
      this.$refs.provider.fetchProductRecommendations({ useCache: false, pageData: this.orderSkus })
    },

    onSelectSize({ item }) {
      const { $notifier } = this

      const scrollingElement = document.querySelector('.mini-cart__container--filled')
      scrollElementTo(scrollingElement, 0)

      if (item.slotId) {
        $notifier.trackEvent({
          action: $notifier.ACTIONS.campaignClick,
          campaignIds: {
            slotId: item.slotId,
          },
          data: { identifier: `mini-cart-recommendation-${item.id}` },
        })
      }
    },
  },
}
</script>
